// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_3Oc2T0","container":"_37jzvN","image":"_1nDCM7"};